/* LIBRARIES */
import React from 'react';
import { ThemeProvider } from 'styled-components';

const multiUse = {
    colors: {
        black: '#000000',
        primary: '#568546',
        secondary: '#44883E',
        white: '#ffffff',
    },
};

const theme = {
    borders: {
        circleImage: `3px solid ${multiUse.colors.secondary}`,
        emergencyFloater: '1px solid #dbdbdb',
        locationResults: '1px solid #E6E6E6',
    },
    borderRadius: {
        default: '2px',
        card: '4px',
    },
    boxShadow: '0 1px 5px rgba(0, 0, 0, 0.19)',
    colors: {
        black: multiUse.colors.black,
        primary: multiUse.colors.primary,
        secondary: multiUse.colors.secondary,
        white: multiUse.colors.white,
        grey:'#979797',
        buttons: {
            disabled: '#9a9fa8',
            primary: multiUse.colors.secondary,
            primaryHover: '#085843',
            secondary: multiUse.colors.primary,
            secondaryHover: '#084779',
            textLink: '#266fc5',
        },
        texts: {
            black: multiUse.colors.black,
            boulderGrey: '#7a7a7a',
            capeCod: '#323333',
            shipGrey: '#404041',
            white: multiUse.colors.white,
            fadedGrey: '#989898',
            placeholderGrey: '#B2B2B2',
            graphite:'#5f5f5f',
            graphiteLight:'#5c5c5c'

        },
        backgrounds: {
            alabaster: '#fafafa',
            altoGrey: '#dbdbdb',
            porcelain: '#edf0f1',
            sand: '#f7f7f5',
            springSky: '#f9fcfd',
            white: multiUse.colors.white,
        },
    },
    fonts: ['Lato', 'Lora', 'Open Sans', 'Roboto'],   
};

const Theme = ({ children }) => (
    <ThemeProvider theme={theme}>{children}</ThemeProvider>
);

export default Theme;
